import styled from 'styled-components';

export const StyledAlignStart = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  margin-top: ${props => props.theme.space[6]}px;
`;

export const StyledLabel = styled.div`
  ${({ theme }) => `
  background: rgba(237, 182, 0, 1);
  padding: ${theme.space[1]}px ${theme.space[3]}px;
  margin: 0 ${theme.space[2]}px;
  border-radius: 9999px;
  font-weight: 500;
  font-size: 13px;
  color: ${theme.color.white};
  `}
`;

export const StyledBanner = styled.div`
  ${({ theme }) => `
  background: rgba(31, 31, 31, 0.05);
  padding: ${theme.space[4]}px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  color: ${theme.color.black};
  `}
`;

export const StyledContainer = styled.div`
  padding: 0 ${({ theme }) => `${theme.space[4]}px ${theme.space[4]}px`};
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: ${({ theme }) => `${theme.space[4]}px ${theme.space[4]}px`};
`;
